define.alias("shared/components/shared/post/secondary/activity/body", "settings/components/shared/post/secondary/activity/body");